import { render, staticRenderFns } from "./Dash-overview.vue?vue&type=template&id=59ffbc7e"
import script from "./Dash-overview.vue?vue&type=script&lang=js"
export * from "./Dash-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports